module.exports = __webpack_public_path__ + "static/consulting-870a2ce4d55fa3ca49c0dc4669de18f2.png";